var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var chatMessageStyles = {
    root: function (_a) {
        var p = _a.props, v = _a.variables;
        return (__assign({ display: 'inline-block', padding: v.padding, borderRadius: v.borderRadius, border: v.border, color: v.color, backgroundColor: p.mine ? v.backgroundColorMine : v.backgroundColor, maxWidth: v.width, wordBreak: 'break-word', wordWrap: 'break-word' }, (p.mine && { float: 'right' }), { ':focus': {
                outline: ".2rem solid " + v.contentFocusOutlineColor,
            } }));
    },
    author: function (_a) {
        var p = _a.props, v = _a.variables;
        return ({
            display: p.mine ? 'none' : undefined,
            marginRight: v.authorMargin,
        });
    },
    content: function (_a) {
        var v = _a.variables;
        return ({
            display: 'block',
            '& a:focus': {
                outline: 'none',
                color: v.contentFocusOutlineColor,
                textDecoration: 'underline',
            },
        });
    },
};
export default chatMessageStyles;
